module.exports = __webpack_public_path__ + "static/media/karl-simons.a6f3a583.jpg";